var urlInput = document.getElementById('ci_consenturl');
if (urlInput != null && urlInput != 'undefined') {
  urlInput.value = encodeURI(window.location.href);
}
function checkbox_Clicked(element) {
  document.getElementById(element.id + '_unchecked').value = !element.checked;
}
function validate_signup(frm, showAlert) {
  var emailAddress = frm.email.value;
  var errorString = '';
  if (emailAddress == '' || emailAddress.indexOf('@') == -1) {
    errorString = 'Please enter your email address';
  }
  var checkBoxValue = frm.ci_userConsentCheckBox.checked;
  if (checkBoxValue == false && showAlert) {
    errorString = 'You must accept the terms';
  }
  if (showAlert) {
    var els = frm.getElementsByTagName('input');
    for (var i = 0; i < els.length; i++) {
      if (els[i].className == 'text' || els[i].className == 'date' || els[i].className == 'number') {
        if (els[i].value == '') errorString = 'Please complete all required fields.';
      } else if (els[i].className == 'radio') {
        var toCheck = document.getElementsByName(els[i].name);
        var radioChecked = false;
        for (var j = 0; j < toCheck.length; j++) {
          if (toCheck[j].name == els[i].name && toCheck[j].checked) radioChecked = true;
        }
        if (!radioChecked) errorString = 'Please complete all required fields.';
      }
    }
  }
  var isError = false;
  if (errorString.length > 0) {
    isError = true;
    if (showAlert) alert(errorString);
  }
  return !isError;
}
